import {Injectable} from '@angular/core';

export interface BadgeItem {
  type: string;
  value: string;
}

export interface ChildrenItems {
  state: string;
  target?: boolean;
  name: string;
  type?: string;
  children?: ChildrenItems[];
}

export interface MainMenuItems {
  state: string;
  short_label?: string;
  main_state?: string;
  target?: boolean;
  name: string;
  type: string;
  icon?: string;
  badge?: BadgeItem[];
  children?: ChildrenItems[];
}

export interface Menu {
  label: string;
  main: MainMenuItems[];
}

const MENUITEMS = [
  {
    label: 'Social Networks',
    main: [
      {
        state: 'Facebook',
        short_label: 'F',
        name: 'Facebook',
        type: 'link',
        //icon: 'icon-home'
      },
      {
        state: 'Instagram',
        short_label: 'I',
        name: 'Instagram',
        type: 'link',
        //icon: 'icon-layout-cta-right'
      },
      {
        state: 'Twitter',
        short_label: 'T',
        name: 'Twitter',
        type: 'link',
        //icon: 'icon-view-grid'
      },
      {
        state: 'Youtube',
        short_label: 'Y',
        name: 'Youtube',
        type: 'link',
       // icon: 'icon-view-grid'
      },
      {
        state: 'LinkedIn',
        short_label: 'L',
        name: 'LinkedIn',
        type: 'link',
       // icon: 'icon-view-grid'
      },
      {
        state: 'Google+',
        short_label: 'G',
        name: 'Google+',
        type: 'link'
      }
    ]
  }
];

@Injectable()
export class MenuItems {
  getAll(): Menu[] {
    return MENUITEMS;
  }
}



// WEBPACK FOOTER //
// C:/Users/apostolos/Documents/globalrank/src/app/shared/menu-items/menu-items.ts